<div class="datepicker">
    <label [for]="id"><span class="label" [innerHTML]="label"></span> <span class="required" *ngIf="required">*</span></label><app-tooltip-card *ngIf="tooltipText" [label]="tooltipLabel" [text]="tooltipText"></app-tooltip-card>
    <input [id]="id" [placeholder]="placeholder" #datepicker>
</div>
